import React from 'react';

import styles from '../styles.module.scss';

interface Props {
  width: string;
  height: string;
  txt: string;
  background: string;
  color: string;
  onClick?: () => void;
}

export default function ModalButton({
  width,
  height,
  txt,
  background,
  color,
  onClick,
}: Props) {
  return (
    <button
      className={styles.button}
      onClick={onClick}
      style={{
        width: width,
        height: height,
        background: background,
        color: color,
      }}>
      {txt}
    </button>
  );
}
